import { useMemo } from "react"

export const useIsCompany = (mode: 'admin' | 'company') => {
  return useMemo(() => mode === 'company', [mode]);
}

export const useIsIsp = (mode: 'admin' | 'company') => {
  return useMemo(() => mode === 'admin', [mode]);
}